import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Prompt } from "react-router-dom";
import GradientProgress from "../common/GradientProgress";
import {BankTile, FinicityConnect, LinkBankFooter, PartnerBanner} from './components'
import { CURRENT_DDA_FLOOR, plaidError, plaidErrorDescription} from './consts'
import { withModal } from "../common";
import Back from "../../assets/Back";
import FinancialProfile from "../../assets/FinancialProfile";
import ConnectBank from "../../assets/ConnectBank";
import GoldLockLogo from '../../assets/gold-lock.png'
import greenCheck from "../../assets/green_check.svg";
import errorIcon from "../../assets/error-icon.svg";
import * as actions from "../../state/actions/onboarding";
import { track } from "../../api/heap";
import isKey from "../../utilities/keyboard-events";
import { uriHasOAuthStateId, uriHasOAuthLogin } from "../../utilities/userInfo";
import LinkBankPlaid from "./LinkBankPlaid";

class LinkBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showRelinkAccounts: null,
      accountsLinked: false,
      linkSuccessful: false,
      error: null,
      initialGreetingShown: false,
      linkBankGreetingShown: false,
      linkInvestmentsGreetingShown: false,
      shouldShowLinkInvestmentsGreeting: false,
      bankQuestionCompleted: false,
      investmentsQuestionCompleted: false,
      hasBankAccounts: null,
      hasInvestmentAccounts: null,
      plaidLinkFromOauth: false,
      openPlaidFromFinicityConnect: false
    };
  }

  async componentDidMount() {
    if (!window.onbeforeunload) {
      window.onbeforeunload = () => {
        return "Refreshing this page will cause you to lose your application progress. Continue?";
      };
    }

    const {
      history,
      loginsRequired,
      finicityLoginsRequired,
      fetchFinicityConnectURL,
      fetchPlaidToken,
      aggregatorType,
    } = this.props;

    const showRelink =
      !!(loginsRequired || []).find(i => i.required && !i.relinked) ||
      !!Object.keys(finicityLoginsRequired || {})
        .map(k => finicityLoginsRequired[k])
        .find(i => !i.relinked);

    if (showRelink) this.setState({ showRelinkAccounts: true });

    this.unlisten = history.listen((location, action) => {
      console.log(
        "ROUTING- history listener called with location",
        location,
        "action",
        action
      );
    });
    
    
    // TODO: Move this somewhere more appropriate, handle potential errors
    if (aggregatorType === "finicity" && !uriHasOAuthStateId()){
      fetchFinicityConnectURL({
        userId: this.props.user.email,
        num: this.props.user.ssn
      });
      return;
    }

    const { fromOauthRedirect } = await fetchPlaidToken({
      userId: this.props.user.email,
      fetchFromDb: uriHasOAuthLogin()
    });
    
    this.setState({ plaidLinkFromOauth: fromOauthRedirect });
  }

  

  componentWillReceiveProps(nextProps) {
    const {
      props: {
        context: { isOpen } = {},
        step: { showUnsupportedAccountsModal } = {}
      } = {}
    } = this;
    if (showUnsupportedAccountsModal && this.openModalButton && !isOpen) {
      this.openModalButton.click();
    }
  }

  componentWillUnmount() {
    if (this.state.plaidLinkOpen) this.removePlaidLink();
    this.unlisten();
  }

  removePlaidLink = () => {
    document.querySelectorAll("iframe").forEach(function(elem) {
      elem.parentNode.removeChild(elem);
    });
    this.resetBodyStyle();
  };

  resetBodyStyle = () => {
    // PlaidLink will overwrite the body to have overflow:hidden
    console.log("resetting body style after Plaid");
    document.body.style.overflow = null;
    // For some reason, the style doesn't always update right away
    setTimeout(() => {
      document.body.style.overflow = null;
    }, 500);
  };

  setRef = openModalButton => {
    this.openModalButton = openModalButton;
  };

  numberOfLinkedAccounts = () => {
    const { props: { step: { linkedAccounts } = {} } = {} } = this;
    return linkedAccounts
      ? Object.keys(linkedAccounts).reduce((a, k) => {
          const la = linkedAccounts[k];
          la.forEach(_ => {
            a += 1;
          });
          return a;
        }, 0)
      : false;
  };

  handlePrevious = () => {  
    this.props.previousStep();
  };

  handleNext = () => {
    console.log("handling next");
    if (this.state.transitioning) return;
    this.setState({ transitioning: true });
    const {
      props: {
        history: { push },
        user: { email } = {},
        step: { stepIsComplete } = {},
        updateUserDatabase,
        updateStep,
        nextStep,
        studentStep: {stepIsComplete: studentStepComplete}
      } = {},
      state: { hasInvestmentAccounts, linkInvestmentsGreetingShown }
    } = this;
    
    if (stepIsComplete) {
      updateUserDatabase(email, {
        applicationProgress: {
          lastCompletedStep: 5,
          linkBank: true,
          lastUpdated: new Date()
        }
      });

      if (studentStepComplete) {
        push({pathname: '/confirm'})
      } else {
        nextStep();
      }
    } else {
      track("ONBOARDING_ERROR_LINK_BANK_STEP", {
        message: "bank_not_linked"
      });
      updateStep("linkBank", {
        error: "You must link a bank account to continue"
      });
    }
  };

  handlePlaidOnExit = (error, metadata) => {
    console.log("link: onExit - error:", error, "metadata", metadata);
    track("ONBOARDING_LINK_BANK_STEP_EXITED_PLAID");
  };

  handlePlaidOnLoad = (error, metadata) => {
    console.log("link: onLoad - error: ", error, "metadata: ", metadata);
  };

  handlePlaidOpen = () => {
    console.log("handling plaid open");
    this.setState({ plaidLinkOpen: true });
  };

  handlePlaidClose = (closeOptions) => {
    console.log("handling plaid close");
    const { 
      email,
      removePlaidToken, 
      fetchPlaidToken,
      plaidLinkToken,
      aggregatorType,
      fetchFinicityConnectURL,
      user
    } = this.props;
    const { deletePlaidLinkInDb } = closeOptions || {};
    
    removePlaidToken({removeFromDb: deletePlaidLinkInDb, plaidLinkToken});
    this.setState({ 
      openPlaidFromFinicityConnect: false,
      plaidLinkFromOauth: false,
      plaidLinkOpen: false
    });
    this.resetBodyStyle();
    
    if (aggregatorType === "finicity"){
      fetchFinicityConnectURL({
        userId: user.email,
        num: user.ssn
      });
      return;
    }
    fetchPlaidToken({ userId: email });
  };

  handlePlaidOnEvent = (eventType, metadata) => {
    console.log(
      "link: plaid event eventType - ",
      eventType,
      "metadata - ",
      metadata
    );
    if (eventType === "OPEN") {
      this.handlePlaidOpen();
      track("ONBOARDING_LINK_BANK_STEP_LOADED_PLAID");
    } else if (eventType === "EXIT") {
      this.handlePlaidClose({deletePlaidLinkInDb: true});
    } else if (eventType === "SELECT_INSTITUTION") {
      track("ONBOARDING_LINK_BANK_STEP_PLAID_SELECTED_INSTITUTION");
    } else if (eventType === "SUBMIT_CREDENTIALS") {
      track("ONBOARDING_LINK_BANK_STEP_PLAID_SUBMITTED_CREDENTIALS");
    }
    if (eventType == "ERROR" && metadata.error_message) {
      this.handlePlaidClose({deletePlaidLinkInDb: true});

      const {
        error_code,
        request_id,
        institution_name,
        institution_id
      } = metadata;

      axios.post("/api/v2/plaid-event", {
        error_code,
        request_id,
        institution_name,
        institution_id
      });

      if (metadata.error_code && plaidError[metadata.error_code]) {
        this.props.updateStep("linkBank", {
          error: plaidErrorDescription[metadata.error_code]
        });
        track("ONBOARDING_ERROR_LINK_BANK_STEP", {
          message: "plaid_error"
        });
      } else {
        this.props.updateStep("linkBank", { error: metadata.error_message });
        // this.setState({ error: metadata.error_message });
        track("ONBOARDING_ERROR_LINK_BANK_STEP", {
          message: "plaid_error"
        });
      }
    }
    if (eventType == "HANDOFF") {
      this.handlePlaidClose();
      // Display a list of added accounts
      this.setState({ accountsLinked: true });
      track("ONBOARDING_LINK_BANK_STEP_PLAID_DONE");
    }
  };

  handlePlaidOnSuccess = (token, metadata) => {
    console.log("Plaid metadata: ", metadata);
    this.setState({ 
      error: null,
      openPlaidFromFinicityConnect: false,
      plaidLinkFromOauth: false
    });

    const {
      updateStep,
      plaidLinkToken,
      linkAccounts
    } = this.props;

    updateStep("linkBank", {
      error: null,
      loading: true
    });

    const accounts = metadata.accounts;
    // Add a default account
    accounts[0].default = true;

    const sentData = {
      public_token: token,
      link_token: plaidLinkToken,
      accounts,
      institution: metadata.institution,
      link_session_id: metadata.link_session_id,
      userId: this.props.user.email
    };

    track("ONBOARDING_LINK_BANK_STEP_PLAID_SUCCESS");

    // TODO: Error-handling, input validation
    // TODO: Is the access token specific to a user or to their bank?
    // If the former, we don't need to get the access token each time.
    // TODO: Split up functions in the backend - separate getting the token,
    // adding banks, getting transactions, etc.
    linkAccounts(sentData);
    this.handlePlaidClose();
  };

  handleRelinkSuccess = async ({ token }) => {
    console.log("handling relink success for token", token);
    this.handlePlaidClose();
    if (!token) return;
    this.props.updateStep("linkBank", {
      loading: true
    });
    const { loginsRequired, setLoginsRequired } = this.props;
    const newLoginsRequired = loginsRequired.map(r => {
      if (r.public_token === token) r.relinked = true;
      return r;
    });
    setLoginsRequired(newLoginsRequired);
    const plaid_item_id = (
      loginsRequired.find(l => l.public_token === token) || {}
    ).itemId;
    const result = await this.props.resolveEvent({
      user_id: this.props.user.email,
      plaid_item_id
    });
    if ((result || {}).decisionRan) {
      this.props.updateStep("linkBank", {
        decisionRan: true
      });
    }
    this.props.updateStep("linkBank", {
      loading: false
    });
  };

  handleFinicityRelinkSuccess = async ({ loginId }) => {
    const { finicityLoginsRequired, setFinicityLoginsRequired } = this.props;
    const updatedFinicityLoginsRequired = { ...finicityLoginsRequired };
    updatedFinicityLoginsRequired[loginId] = {
      ...updatedFinicityLoginsRequired[loginId],
      relinked: true
    };
    setFinicityLoginsRequired(updatedFinicityLoginsRequired);
  };

  anyUnlinked = () =>
    !!(this.props.loginsRequired || []).find(i => i.required && !i.relinked) ||
    !!Object.keys(this.props.finicityLoginsRequired || {})
      .map(k => this.props.finicityLoginsRequired[k])
      .find(i => !i.relinked);

  renderError = (message = "") => {
    return (
      <div style={{ color: "red" }}>{`${(`${message}` || "")
        .slice(0, 1)
        .toUpperCase()}${(`${message}` || "").slice(
        1,
        (`${message}` || "").length
      )}`}</div>
    );
  };

  renderWarningsModalButton = () => {
    const {
      props: {
        context: { openModal },
        step: { accountWarnings }
      }
    } = this;
    return (
      <button
        style={{ outline: "none" }}
        className="inline-block cursor-pointer mt-8 font-open-sans text-sm border-2 border-red-500 py-1 px-6 rounded-full text-red-500 hover:bg-red-500 hover:text-white outline-none"
        onClick={e => {
          openModal(e, "LinkBankWarningsDetailsModal", { accountWarnings });
        }}
      >
        <i className="far fa-exclamation-circle mr-1"></i>
        <p className="inline-block">Account Linking Errors</p>
      </button>
    );
  };

  renderUnsupportedAccounts = () => {
    const {
      props: {
        context: { openModal },
        step: { unsupportedAccounts },
        updateStep
      }
    } = this;
    return (
      <button
        style={{ outline: "none" }}
        className="hidden inline-block cursor-pointer mt-8 font-open-sans text-sm border-2 border-red-500 py-1 px-6 rounded-full text-red-500 hover:bg-red-500 hover:text-white outline-none"
        onClick={e => {
          openModal(e, "UnsupportedAccountsDetailsModal", {
            unsupportedAccounts,
            onClose: () => {
              updateStep("linkBank", { showUnsupportedAccountsModal: false });
            }
          });
        }}
        ref={this.setRef}
      >
        <i className="far fa-exclamation-circle mr-1"></i>
        <p className="inline-block">Unsupported Accounts</p>
      </button>
    );
  };

  renderLoadingIndicator = loading => (
    <div
      className="loader"
      style={{
        // position: "relative",
        height: 60,
        width: 60,
        // left: 0,
        // right: 0,
        margin: "auto",
        // bottom: 40
        visibility: loading ? "visible" : "hidden"
      }}
    ></div>
  );

  renderPlaidLink = ({
    continueStyle = false,
    boxStyle = false,
    hidden = this.props.aggregatorType === "finicity",
    text,
    fromFinicityConnect
  }) => {
    if(!this.props.plaidLinkToken)
      return null;

    return (
      <div id="plaid-button-div" className={hidden ? "hidden" : ""}>
        <LinkBankPlaid 
          linkToken={this.props.plaidLinkToken}
          fromOauthRedirect={this.state.plaidLinkFromOauth}
          boxStyle={boxStyle}
          continueStyle={continueStyle}
          text={text}
          onEvent={this.handlePlaidOnEvent}
          onExit={this.handlePlaidOnExit}
          onLoad={this.handlePlaidOnLoad}
          onSuccess={this.handlePlaidOnSuccess}
          fromFinicityConnect={fromFinicityConnect}
        />
      </div>
    );
  };

  renderRelinkButton = ({ onClick, token, link_token }) => {
    const {
      state: { 
        relinking, 
        loading,
        plaidLinkFromOauth
      },
      handleRelinkSuccess
    } = this;
    const relinkEvent = (e, md) => {
      console.log("relink event:", e, md);
      this.setState({ relinking: true });
      if (e === "OPEN") {
        this.handlePlaidOpen();
      } else if (e === "EXIT") {
        this.handlePlaidClose({ deletePlaidLinkInDb: true });
      } else if (e === "HANDOFF") {
        this.handlePlaidClose();
      }

      // To Do: Handle invalid link tokens
      // else if (e === "INVALID_LINK_TOKEN") {
      //   ...
      // }
    };
    const relinkExit = (e, md) => {
      console.log("relink exit:", e, md);
      this.handlePlaidClose({ deletePlaidLinkInDb: true });
      const { error_code } = e || md || {};
      if (error_code === "INVALID_PUBLIC_TOKEN") {
        window.localStorage.removeItem("jwt");
        window.onbeforeunload = null;
        window.location.reload();

        // TODO: Fetch new public tokens
        // console.log("Public token is not valid, fetching new ones");
        // this.setState({ loading: true });
        return;
      }
      this.setState({ relinking: false });
    };
    const relinkLoad = (e, md) => console.log("relink load:", e, md);
    const relinkSuccess = (e, md) => {
      console.log("relink success:", e, md);
      const { plaid_id } = md;
      handleRelinkSuccess({ token, plaid_id });
      this.setState({ relinking: false });
    };

    const relinkButtonJSX = (
      <div className="px-2 flex">
        <img src={errorIcon} className="" alt="Error Icon" />
        <span className="ml-2">Re-link</span>
      </div>
    )
    return relinking || loading ? (
      <div
        className={
          "bg-gray-400 text-sm font-medium text-white px-2 py-1 rounded cursor-not-allowed"
        }
      >
        <div className="px-2 flex">
          <img src={errorIcon} className="" alt="Error Icon" />
          <span className="ml-2">Re-link</span>
        </div>
      </div>
    ) : (
      <LinkBankPlaid 
        key={link_token}
        linkToken={plaidLinkFromOauth && uriHasOAuthStateId ? this.props.plaidLinkToken : link_token}
        fromOauthRedirect={plaidLinkFromOauth}
        boxStyle={true}
        continueStyle={true}
        text={relinkButtonJSX}
        onExit={relinkExit}
        onLoad={relinkLoad}
        onSuccess={relinkSuccess}
      />
    );
  };

  renderRelinkButtonFinicity = ({ onClick, link, onSuccess = () => {} }) => {
    const {
      props: { updateStep },
      state: { relinking, loading },
      handleRelinkSuccess
    } = this;
  return relinking || loading ? (
      <div
        className={
          "bg-gray-400 text-sm font-medium text-white px-2 py-1 rounded cursor-not-allowed"
        }
      >
        <div className="px-2 flex">
          <img src={errorIcon} className="" alt="Error Icon" />
          <span className="ml-2">Re-link</span>
        </div>
      </div>
    ) : (
      <FinicityConnect
        linkURL={link}
        finicityCustomerId={this.props.finicityCustomerId}
        email={this.props.email}
        onSuccess={data => {
          console.log("onSuccess data:", data);
          const { code } = data;
          if (code === 200) {
            onSuccess();
          } else {
            console.log(
              "FinicityConnect relink onSuccess did not have successful status code"
            );
          }
        }}
        onCancel={data => {
          console.log("onCancel data:", data);
        }}
        onError={data => {
          console.log("onError data:", data);
          const { code } = data;
          if (code === 201) {
            console.log(
              "FinicityConnect relink onError code 201 - already linked"
            );
            onSuccess();
          }
        }}
        onLoaded={data => {
          console.log("onLoaded data:", data);
        }}
        onRouteEvent={data => {
          console.log("onRouteEvent data:", data);
        }}
        onUserEvent={data => {
          console.log("onUserEvent data:", data);
        }}
        buttonText={"Re-link"}
        buttonClassName={
          "shadow-xl bg-red-400 hover:bg-red-500 text-sm font-medium text-white px-2 py-1 rounded w-full cursor-pointer"
        }
      />
    );
  };

  renderSelectionButton = ({ text, selected, onSelect, key }) => {
    return (
      <button
        className={`rounded-full flex justify-center p-3 hover:text-primary ${selected &&
          "font-black"}`}
        style={{
          border: `3px solid ${selected ? "#26E3BA" : "transparent"}`,
          height: 50,
          width: 50,
          outline: "none",
          transition: "border 0.3s, color 0.3s"
        }}
        onClick={onSelect}
        key={key}
      >
        <span style={{ color: selected ? "#26E3BA" : "" }}>{text}</span>
        {/* this is a hack to preload the bold font and prevent jumpy layout */}
        <span className="font-black opacity-0 absolute">a</span>
      </button>
    );
  };

  renderQuestion = ({ question, options, criterion, completion }) => {
    const {
      state: { [criterion]: criterionValue, error },
      renderError,
      renderSelectionButton
    } = this;
    return (
      <>
        <div
          className="outerStack-mobile sm:outerStack"
          onKeyDown={e => {
            if (isKey(e, ["enter"])) {
              e.preventDefault();
              completion();
            }
          }}
        >
          <div className="innerStack">
            <div className="stepDescriptionText">{question}</div>
            <div className="flex justify-between w-7/12 mx-auto">
              {options.map((option, index) =>
                renderSelectionButton({
                  text: option.text,
                  selected: option.value[criterion] === criterionValue,
                  onSelect: () => {
                    console.log("on selecting...");
                    this.setState(option.value);
                    // track("ONBOARDING_LINK_BANK_STEP_SELECTED_OPTION", { value });
                  },
                  key: question + option.text
                })
              )}
            </div>
            <div>
              <input
                autoFocus
                type="button"
                name="button"
                value="Continue"
                className={`continueButton ${!error && `cursor-pointer`}`}
                style={{
                  backgroundColor:
                    criterionValue !== null && !error ? "#26E3BA" : "gray"
                }}
                disabled={criterionValue === null || error}
                onClick={completion}
              />
            </div>
            {error && renderError(error)}
          </div>
        </div>
      </>
    );
  };

  // renderError = message => <div style={{ color: "red" }}>{message}</div>;

  renderInitialGreeting = () => {
    console.log("renderInitialGreeting");
    const {
      renderError,
      props: {
        step: { error: stepError }
      }
    } = this;
    return (
      <>
        <div className="outerStack-mobile sm:outerStack">
          <div className="innerStack">
            <div className="stepDescriptionText">
              Let's build your financial profile
            </div>
            <div>
              <FinancialProfile
                className="mx-auto"
                style={{ paddingBottom: 30 }}
              />
            </div>
            <div className="w-4/5 m-auto text-justify">
              <div>
                <b className="text-purple-500">
                  Why is my financial profile important?
                </b>
              </div>
              <span>
                Your financial profile allows us to learn more about you and
                helps us give you the credit you deserve.
              </span>
            </div>
            <input
              autoFocus
              type="button"
              name="button"
              value="Let's go!"
              className="continueButton cursor-pointer"
              style={{
                backgroundColor: "#26E3BA",
                outline: "none"
              }}
              onClick={() => {
                this.setState({ initialGreetingShown: true });
              }}
            />
          </div>
          {stepError && renderError(stepError)}
        </div>
      </>
    );
  };

  renderBankQuestion = () => {
    console.log("renderBankQuestion");
    const criterion = "hasBankAccounts";
    return this.renderQuestion({
      question: "Do you have any bank accounts?",
      options: [
        { text: "Yes", value: { [criterion]: true, error: null } },
        {
          text: "No",
          value: {
            [criterion]: false,
            error: "You must have at least one bank account to continue"
          }
        }
      ],
      criterion,
      completion: () => {
        if (this.state.hasBankAccounts) {
          this.props.progressOverride("add", 25);
          this.setState({
            bankQuestionCompleted: true,
            investmentsQuestionCompleted: null
          });
        }
      }
    });
  };

  renderInvestmentsQuestion = () => {
    console.log("renderInvestmentsQuestion");
    const criterion = "hasInvestmentAccounts";
    return this.renderQuestion({
      question: "Do you have any investment accounts?",
      options: [
        { text: "Yes", value: { [criterion]: true } },
        { text: "No", value: { [criterion]: false } }
      ],
      criterion,
      completion: () => {
        this.props.progressOverride("add", 25);
        this.setState({
          investmentsQuestionCompleted: true
        });
      }
    });
  };

  renderLinkBankGreeting = () => {
    console.log("renderLinkBankGreeting");
    const {
      renderPlaidLink,
      renderError,
      props: {
        step: { error: stepError },
        updateStep
      }
    } = this;
    return (
      <>
        <div
          className="outerStack-mobile sm:outerStack"
          onKeyDown={e => {
            console.log("here selecting...");
            const plaidDivEl = document.getElementById("start-linking");
            const plaidButtonEl = plaidDivEl.getElementsByClassName(
              "continueButton"
            );
            plaidButtonEl[0].click();
          }}
        >
          <div className="innerStack">
            <div className="stepDescriptionText">
              Let's link
              <br />
              your acounts
            </div>
            <div>
              <ConnectBank className="mx-auto" style={{ paddingBottom: 30 }} />
            </div>
            <div className="w-4/5 m-auto text-center">
              <span>
                <b className="text-purple-500">Pro tip: </b>
                Users who link more accounts generally get higher spending power
              </span>
            </div>
            <button
              autoFocus
              id="start-linking"
              className="w-full"
              style={{ outline: "none" }}
            >
              {renderPlaidLink({
                continueStyle: true,
                text: "Start linking",
                additionalProducts: ["auth"],
                onClick: () => {
                  this.setState({
                    linkBankGreetingShown: true
                  });
                  updateStep("linkBank", {
                    accountErrors: [],
                    accountWarnings: []
                  });
                }
              })}
            </button>
          </div>
          {stepError && renderError(stepError)}
        </div>
      </>
    );
  };

  renderLinkInvestmentsGreeting = () => {
    console.log("renderLinkInvestmentsGreeting");
    const {
      renderError,
      handleNext,
      props: {
        user: { estimatedLimit },
        step: { linkedAccounts, error: stepError }
      }
    } = this;

    return (
      <>
        <div className="outerStack-mobile sm:outerStack">
          <div className="innerStack">
            <div className="stepDescriptionText">
              Are you sure that's all the accounts you want to link?
            </div>
            <div className="font-gilroy font-light text-md mb-8">
              The more accounts you add, the higher spending power you get! You can add
              investment accounts as well.
            </div>
            <div>
              <GradientProgress
                value={estimatedLimit || 0}
                title="Estimated spending power:"
                max={1000}
                maxLabel="$1000+"
                labelSuffix={estimatedLimit >= 1000 ? "+" : ""}
                backgroundColor="white"
              />
            </div>
            <input
              type="button"
              name="button"
              value="I have more"
              className="continueButton cursor-pointer"
              style={{
                backgroundColor: "#26E3BA"
              }}
              onClick={() => {
                this.setState({
                  linkInvestmentsGreetingShown: false,
                  shouldShowLinkInvestmentsGreeting: false
                });
              }}
            />
            <br />
            <input
              type="button"
              name="button"
              value="Nope, I'm good"
              disabled={this.state.transitioning}
              className="cursor-pointer text-gray-600 bg-transparent"
              onClick={handleNext}
            />
          </div>
          {stepError && renderError(stepError)}
        </div>
      </>
    );
  };

  renderFinicityAccounts = ({ type }) => {
    const {
      step: { finicityAccounts = [], finicityInstitutions = {}, loading } = {},
      removeFinicityAccount
    } = this.props;
    let accounts;
    if (type == "depository") {
      accounts = finicityAccounts.filter(a =>
        ["checking", "savings"].includes(a.type)
      );
    } else if ((type = "investment")) {
      accounts = finicityAccounts.filter(
        a => !["checking", "savings"].includes(a.type)
      );
    } else {
      accounts = finicityAccounts;
    }

    const getLogo = id =>
      ((finicityInstitutions[id] || {}).branding || {}).icon;

    return accounts.map(a => {
      const logo = getLogo(a.institution_id);
      return (
        <BankTile
          key={a.mask + a.institution_id}
          logoUrl={logo}
          name={a.name}
          accountNumber={a.mask}
          handleRemove={() => removeFinicityAccount(a.id)}
          disabled={loading}
        />
      );
    });
  };

  renderLinkedAccounts = () => {
    console.log("renderLinkedAccounts");
    const {
      handleNext,
      handlePrevious,
      renderError,
      renderWarningsModalButton,
      renderUnsupportedAccounts,
      renderPlaidLink,
      renderLoadingIndicator,
      renderFinicityAccounts,
      state: { 
        error, 
        plaidLinkOpen,
        openPlaidFromFinicityConnect
      },
      props: {
        networkingError,
        isMobile,
        removeAccount,
        fetchPlaidToken,
        updateFinicityAccounts,
        user: { finicityConnectURL },
        aggregatorType,
        step: {
          loading,
          linkedAccounts,
          finicityAccounts,
          unsupportedAccounts,
          institutions,
          stepIsComplete,
          error: stepError,
          accountErrors,
          accountWarnings
        },
        context: { openModal },
        progressOverride
      }
    } = this;

    const depositoryAccountLinked =
      !!Object.keys(linkedAccounts || {}).find(
        i =>
          !!linkedAccounts[i].find(a =>
            ["checking", "savings"].includes(a.subtype)
          )
      ) ||
      !!(finicityAccounts || []).find(i =>
        ["checking", "savings"].includes(i.type)
      );

    progressOverride("set", 75);

    const isBank = account => {
      const types = ["checking", "savings", "money market"];
      return types.includes(account.type) || types.includes(account.subtype);
    };
    const isInvestment = account => {
      const types = [
        "cd",
        "401k",
        "brokerage",
        "ira",
        "pension",
        "roth",
        "roth 401k"
      ];
      return types.includes(account.type) || types.includes(account.subtype);
    };
    const getInstitutionLogo = name => {
      return (
        institutions &&
        (institutions.filter(i => i.brand_name === name).pop() || {}).logo
      );
    };

    const allAccounts = linkedAccounts || {};

    const bankAccounts = Object.keys(allAccounts).reduce((a, k) => {
      const la = allAccounts[k];
      la.forEach(account => {
        if (isBank(account)) {
          a.push({
            id: account.id,
            logo: getInstitutionLogo(k) || null,
            name: account.name || account.nickname,
            mask: account.mask,
            identity_valid: account.identity_valid,
            identity_details: account.identity_details
          });
        }
      });
      return a;
    }, []);

    const investmentAccounts = Object.keys(allAccounts).reduce((a, k) => {
      const la = allAccounts[k];
      la.forEach(account => {
        if (isInvestment(account)) {
          a.push({
            id: account.id,
            logo: getInstitutionLogo(k) || null,
            name: account.name || account.nickname,
            mask: account.mask,
            identity_valid: account.identity_valid,
            identity_details: account.identity_details
          });
        }
      });
      return a;
    }, []);

    const finicityBankAccounts = (finicityAccounts || []).filter(a =>
      ["checking", "savings"].includes(a.type)
    );
    const finicityInvestmentAccounts = (finicityAccounts || []).filter(
      a => !["checking", "savings"].includes(a.type)
    );

    const someAccounts =
      (bankAccounts || []).length ||
      (investmentAccounts || []).length ||
      (finicityBankAccounts || []).length ||
      (finicityInvestmentAccounts || []).length;

    const showCapitalOneTip = !!(
      (finicityAccounts || []).filter(a =>
        ["170778"].includes(a.institution_id)
      ) || []
    ).length;

    return (
      <>
        <Prompt
          when={!!plaidLinkOpen}
          message={(location, action) => {
            return "Are you sure you want to leave? You will lose all unsaved progress.";
          }}
        />
        <div className="outerStack-mobile sm:outerStack">
          <div className="innerStack">
            {(this.props.studentStep || {}).stepIsComplete ? (
              <>
                <div className="stepDescriptionText">
                  {stepIsComplete && someAccounts
                    ? "Connect additional accounts to increase chances of approval"
                    : "Link your primary checking and savings account"}
                </div>
                <div className='flex flex-row items-center mb-5 text-sm'>
                <div
                  className="flex flex-col items-center font-gilroy font-light"
                >
                  {stepIsComplete && someAccounts ? (
                    <>
                      <p>
                        A minimum of {CURRENT_DDA_FLOOR} in total bank account balances is
                        recommended for approval.
                      </p>
                      <br />
                      <p>
                      Higher total balances have greater chance of higher spending power.
                      </p>
                      
                    </>
                    
                  ) : (
                    <>
                      <p>
                        Bank linking is required for application submission. A
                        minimum of {CURRENT_DDA_FLOOR} in total bank account balances is
                        recommended for approval.
                     </p>
                      <br />
                      Connect multiple bank accounts to increase your total
                      balance and chance of approval.
                    </>
                  )}
                </div>
                </div>
              </>
            ) : (
              <>
                <div className="stepDescriptionText">
                  {stepIsComplete && someAccounts
                    ? "Make sure you have all your accounts added"
                    : "Tomo securely connects to your bank to determine spending power."}
                </div>
                <p className="mx-5 text-gray-600 pb-3">
                  Since we never do credit checks, we consider your cash flow and banking history for approval and spending power determination.
                </p>
              </>
            )}
          {someAccounts && !depositoryAccountLinked && !loading ? (
            <div className="pb-4">
              {renderError(
                "You must link a checking or savings account to continue"
              )}
            </div>
          ) : null}
          {error && renderError(error)}
          {stepError && renderError(stepError)}
          {networkingError && renderError(networkingError)}
            {(bankAccounts.length > 0 || finicityBankAccounts.length > 0) && (
              <div className="font-gilroy font-light text-lg pb-3">
                Bank accounts
              </div>
            )}

            <div className="mb-4">
              {renderFinicityAccounts({ type: "depository" })}
              {bankAccounts.map((a) => (
                <BankTile
                  logo={a.logo}
                  name={a.name || a.nickname}
                  accountNumber={a.mask}
                  triggerOnHover={!isMobile}
                  showWarning={
                    !([true, false].includes(a.identity_valid)
                      ? a.identity_valid
                      : true)
                  }
                  handleRemove={() => {
                    removeAccount(a.id);
                  }}
                  warningAction={(e) => {
                    const filteredWarnings = (accountWarnings || []).filter(
                      (w) => w.id === a.id
                    );
                    const filteredBankAccounts = (bankAccounts || []).filter(
                      (b) => b.id === a.id
                    );
                    let ourWarning = [];
                    if (filteredBankAccounts.length)
                      ourWarning = filteredBankAccounts.reduce(
                        (a, i) => [
                          ...a,
                          {
                            account: {
                              id: i.id,
                              mask: i.mask,
                              nickname: i.name,
                              type: i.type,
                            },
                            details: ((i.identity_details || [])[0] || {})
                              .results,
                          },
                        ],
                        []
                      );
                    if (filteredWarnings.length) ourWarning = filteredWarnings;
                    openModal(e, "LinkBankWarningsDetailsModal", {
                      accountWarnings: ourWarning,
                    });
                  }}
                  disabled={loading}
                />
              ))}
            </div>

            {(investmentAccounts.length > 0 ||
              finicityInvestmentAccounts.length > 0) && (
              <>  
                <div className="font-gilroy font-light text-lg pb-3">
                  Other accounts
                </div>
                <div className="mb-4">
                  {renderFinicityAccounts({ type: "investment" })}
                  {investmentAccounts.map((a) => (
                    <BankTile
                      logo={a.logo}
                      name={a.name || a.nickname}
                      accountNumber={a.mask}
                      triggerOnHover={!isMobile}
                      showWarning={
                        !([true, false].includes(a.identity_valid)
                          ? a.identity_valid
                          : true)
                      }
                      handleRemove={() => {
                        removeAccount(a.id);
                      }}
                      warningAction={(e) => {
                        const filteredWarnings = (accountWarnings || []).filter(
                          (w) => w.id === a.id
                        );
                        const filteredInvestmentAccounts = (
                          investmentAccounts || []
                        ).filter((i) => i.id === a.id);
                        let ourWarning = [];
                        if (filteredInvestmentAccounts.length)
                          ourWarning = filteredInvestmentAccounts.reduce(
                            (a, i) => [
                              ...a,
                              {
                                account: {
                                  id: i.id,
                                  mask: i.mask,
                                  nickname: i.name,
                                  type: i.type,
                                },
                                details: {
                                  ...((i.identity_details || [])[0] || {})
                                    .results,
                                },
                              },
                            ],
                            []
                          );
                        if (filteredWarnings.length)
                          ourWarning = filteredWarnings;
                        openModal(e, "LinkBankWarningsDetailsModal", {
                          accountWarnings: ourWarning,
                        });
                      }}
                      disabled={loading}
                    />
                  ))}
                </div>
              </>
            )}

            {(accountWarnings || []).length ? (
              renderWarningsModalButton()
            ) : (
              <></>
            )}
            {(unsupportedAccounts || []).length ? (
              renderUnsupportedAccounts()
            ) : (
              <></>
            )}

            {aggregatorType === "finicity" && (
              <div className="flex items-center justify-center">
                <FinicityConnect
                  finicityCustomerId={this.props.finicityCustomerId}
                  email={this.props.email}
                  linkURL={finicityConnectURL}
                  disabled={loading}
                  hidden={loading}
                  allowShowMore
                  showMoreAccounts={async () => {
                    const { fromOauthRedirect } = await fetchPlaidToken({
                      userId: this.props.user.email
                    });
                                        
                    console.log(`fromOauthRedirect from Finicity Modal: ${fromOauthRedirect}`);
                    
                    this.setState({ 
                      plaidLinkFromOauth: fromOauthRedirect,  
                      openPlaidFromFinicityConnect: true
                    });
                  }}
                  onSuccess={(data) => {
                    console.log("onSuccess data:", data);
                    updateFinicityAccounts({});
                  }}
                  onCancel={(data) => {
                    console.log("onCancel data:", data);
                    updateFinicityAccounts({});
                  }}
                  onError={(data) => {
                    console.log("onError data:", data);
                  }}
                  onLoaded={(data) => {
                    console.log("onLoaded data:", data);
                  }}
                  onRouteEvent={(data) => {
                    console.log("onRouteEvent data:", data);
                  }}
                  onUserEvent={(data) => {
                    console.log("onUserEvent data:", data);
                  }}
                  buttonText={
                    someAccounts ? "+ Add another" : "+ Add an account"
                  }
                  buttonClassName={
                    someAccounts
                      ? "bg-green-primary opacity-75 addAccBtn w-full py-2 text-white text-lg rounded cursor-pointer"
                      : "continueButton-noMargin rounded"
                  }
                />
              </div>
            )}

            {!loading
              ? renderPlaidLink({
                  continueStyle: true,
                  boxStyle: !!(stepIsComplete && someAccounts),
                  text:
                    stepIsComplete && someAccounts
                      ? "+ Add another"
                      : "+ Add account",
                  fromFinicityConnect: openPlaidFromFinicityConnect
                })
              : null}

            {showCapitalOneTip && (
              <>
                <div className="flex flex-row items-center justify-center pr-3 mt-4">
                  <img className="h-5 w-5 mb-1 pr-2" src={GoldLockLogo} />
                  <span>Secure & Encrypted</span>
                </div>
                <div className="shadow bg-white rounded mt-4 p-3">
                  <p className="text-left pb-1">
                    <i className="far fa-exclamation-circle mr-1 text-yellow-500"></i>
                    <b>Attention</b>
                  </p>
                  <p className="p-1">
                    We see that you've added a Capital One account.
                  </p>
                  <p>
                    Make sure you{" "}
                    <b>grant access to Account Number & Routing Number</b>{" "}
                    before continuing, or your application may be considered
                    incomplete.
                  </p>
                  <p className="p-1">
                    If you need to make changes, click "Add another" above and
                    review your existing Bank Connections.{" "}
                  </p>
                  <p>
                    <i className="p-1">
                      You may need to remove and re-add your bank.
                    </i>
                  </p>
                </div>
              </>
            )}

            <PartnerBanner isLockLogoVisible={!showCapitalOneTip} />

            {loading && renderLoadingIndicator(loading)}

            {stepIsComplete && depositoryAccountLinked && (
              <div className="pt-6">
                <button
                  className="continueButton"
                  disabled={loading || this.state.transitioning}
                  onClick={handleNext}
                >
                  Continue
                </button>
              </div>
            )}
            <p className="mt-4">
              <a
                href="/application-troubleshooting"
                rel="noopener noreferrer"
                target="_blank"
                className="underline hover:text-green-primary"
              >
                Trouble connecting your account?
              </a>
            </p>
          </div>

          <div className="bottomBar">
            <div className="bottomBarText-mobile sm:bottomBarText">
              <div onClick={handlePrevious}>
                <Back className="backButtonIcon" />
                <input
                  type="button"
                  name="button"
                  value="Back"
                  className="backButton"
                />
              </div>
            </div>
          </div>
        </div>
        <LinkBankFooter />
      </>
    );
  };

  renderRelinkAccounts = () => {
    console.log("renderRelinkAccounts");
    const {
      anyUnlinked,
      handleNext,
      handlePrevious,
      handleFinicityRelinkSuccess,
      renderError,
      renderWarningsModalButton,
      renderUnsupportedAccounts,
      renderPlaidLink,
      renderLoadingIndicator,
      renderRelinkButton,
      renderRelinkButtonFinicity,
      state: { linkInvestmentsGreetingShown, error },
      props: {
        networkingError,
        isMobile,
        removeAccount,
        removeFinicityAccount,
        updateStep,
        user: { estimatedLimit },
        step: {
          loading,
          linkedAccounts,
          finicityAccounts,
          unsupportedAccounts,
          institutions,
          finicityInstitutions,
          stepIsComplete,
          error: stepError,
          accountErrors,
          accountWarnings
        },
        context: { openModal },
        progressOverride,
        loginsRequired,
        finicityLoginsRequired,
        setLoginsRequired,
        applicationProgress
      }
    } = this;

    const getInstitutionLogo = name => {
      return (
        institutions &&
        (institutions.filter(i => i.brand_name === name).pop() || {}).logo
      );
    };

    const allAccounts = Object.keys(linkedAccounts || {}).reduce((a, k) => {
      const la = linkedAccounts[k];
      la.forEach(account => {
        a.push({
          id: account.id,
          logo: getInstitutionLogo(k) || null,
          name: account.name || account.nickname,
          mask: account.mask,
          identity_valid: account.identity_valid,
          identity_details: account.identity_details
        });
      });
      return a;
    }, []);

    const someLinked =
      !!Object.keys(linkedAccounts || {}).length ||
      !!Object.keys(finicityAccounts || {}).length;

    const row = ({
      name = "No Name",
      mask = "XXXX",
      linked = false,
      id,
      finicity = false
    }) => (
      <div className="flex text-left ml-6 pl-6 rounded mb-1">
        <div className="flex justify-between w-full inline-block">
          <span className="text-gray-500 cursor-default">{`${name} (**${mask})`}</span>
          {linked ? (
            <span className="mr-6">
              <img
                src={greenCheck}
                className="inline-block self-center"
                alt="checkmark"
              />
            </span>
          ) : (
            <div
              className="text-gray-400 hover:text-red-500 text-xs self-center cursor-pointer inline-block mr-4"
              onClick={() =>
                finicity ? removeFinicityAccount(id) : removeAccount(id)
              }
            >
              Remove
            </div>
          )}
        </div>
      </div>
    );

    const unlinked = anyUnlinked();

    const renderLinked = () => {
      return (
        <div>
          {(loginsRequired || []).map((i, index) => {
            const { institutionId, relinked, accounts, public_token, link_token } = i;
            const ins =
              institutions
                .filter(x => x.institution_id === institutionId)
                .pop() || {};
            const { logo, brand_name } = ins || {};
            const affectedAccounts = Object.keys(linkedAccounts || {}).reduce(
              (a, c) => {
                (linkedAccounts[c] || []).forEach(x => {
                  const { id, ...rest } = x;
                  if ((accounts || []).includes(x.id)) a[id] = { id, ...rest };
                });
                return a;
              },
              {}
            );

            return (
              <div
                className={`${
                  index > 0 ? "mt-6 pt-4 border-t border-dashed" : ""
                }`}
              >
                <div className="flex justify-between p-2">
                  <div className="text-left ml-4">
                    <img
                      src={
                        logo
                          ? `data:image/png;base64,${logo}`
                          : "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
                      }
                      alt="Bank Logo"
                      className="self-center inline-block"
                      style={{
                        height: 30
                      }}
                    ></img>
                    <span className="ml-2 self-center">{brand_name}</span>
                  </div>
                  <div>
                    {!relinked ? (
                      renderRelinkButton({
                        onClick: () => console.log("relink clicky"),
                        token: public_token,
                        link_token
                      })
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {Object.keys(affectedAccounts).map(a => {
                  const { id, name, mask } = affectedAccounts[a];
                  return row({ name, mask, linked: relinked, id });
                })}
              </div>
            );
          })}
          {(Object.keys(finicityLoginsRequired || {}) || []).length ? (
            (() => {
              return Object.keys(finicityLoginsRequired).map((i, index) => {
                const {
                  link,
                  accounts,
                  institutionId,
                  relinked = false
                } = finicityLoginsRequired[i];
                const {
                  branding: { icon: logo } = {},
                  institution: {
                    name: institution_name = "Unknown Institution"
                  } = {}
                } = (finicityInstitutions || {})[institutionId] || {};
                return (
                  <div
                    className={`${
                      index > 0 ? "mt-6 pt-4 border-t border-dashed" : ""
                    }`}
                  >
                    <div className="flex justify-between p-2">
                      <div className="text-left ml-4">
                        <img
                          src={
                            logo ||
                            "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
                          }
                          alt="Bank Logo"
                          className="self-center inline-block"
                          style={{
                            height: 30
                          }}
                        ></img>
                        <span className="ml-2 self-center">
                          {institution_name}
                        </span>
                      </div>
                      <div>
                        {!relinked ? (
                          renderRelinkButtonFinicity({
                            onClick: () =>
                              console.log("finicity relink clicky"),
                            link,
                            onSuccess: () =>
                              handleFinicityRelinkSuccess({ loginId: i })
                          })
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {accounts.map(a => {
                      const { id, name, mask } = a;
                      return row({
                        name,
                        mask,
                        linked: relinked,
                        id,
                        finicity: true
                      });
                    })}
                  </div>
                );
              });
            })()
          ) : (
            <></>
          )}
        </div>
      );
    };
    return (
      <>
        <div className="outerStack-mobile sm:outerStack">
          <div className="innerStack">
            <div className="stepDescriptionText">
              {!someLinked
                ? "You must link an account to continue"
                : unlinked
                ? "Some of your accounts need to be re-linked"
                : "You're good to Go!"}
            </div>
            <div className="font-gilroy font-light text-md pb-3 px-10 md:px-0">
              {!someLinked
                ? "Click Continue to add your accounts"
                : unlinked
                ? "We had an issue with the following accounts. Please re-link to continue"
                : "You have no more accounts that need linking."}
            </div>

            {!someLinked || !unlinked ? (
              <></>
            ) : (
              <div className="font-gilroy font-light text-lg pb-3">
                Accounts
              </div>
            )}

            <div className="mb-4">{renderLinked()}</div>

            {loading && !stepIsComplete && renderLoadingIndicator(loading)}

            {(accountWarnings || []).length ? (
              renderWarningsModalButton()
            ) : (
              <></>
            )}
            {(unsupportedAccounts || []).length ? (
              renderUnsupportedAccounts()
            ) : (
              <></>
            )}

            {loading && stepIsComplete && renderLoadingIndicator(loading)}
            {
              <div className="pt-6">
                <button
                  className={`continueButton-noMargin ${
                    unlinked || loading ? "cursor-not-allowed" : ""
                  }`}
                  style={unlinked || loading ? { background: "lightgray" } : {}}
                  disabled={unlinked || loading}
                  onClick={() => {
                    setLoginsRequired(null);

                    if (!someLinked) {
                      this.setState({ showRelinkAccounts: false });
                      return;
                    }
                    if (this.props.step.decisionRan) {
                      this.props.history.push("/decision");
                      return;
                    }
                    if ((applicationProgress || {}).lastCompletedStep >= 5) {
                      this.props.history.push("/resumeapplication");
                    }
                    console.log("applicationProgress:", applicationProgress);
                    this.setState({ showRelinkAccounts: false });
                  }}
                >
                  Continue
                </button>
                <PartnerBanner />
              </div>
            }
          </div>
          {error && renderError(error)}
          {stepError && renderError(stepError)}
          {networkingError && renderError(networkingError)}
          <LinkBankFooter />
        </div>
      </>
    );
  };

  render() {
    const {
      anyUnlinked,
      renderLinkInvestmentsGreeting,
      renderLinkedAccounts,
      renderRelinkAccounts,
      state: {
        shouldShowLinkInvestmentsGreeting,
        showRelinkAccounts
      },
    } = this;

    const unlinked = anyUnlinked();

    return unlinked || showRelinkAccounts
      ? renderRelinkAccounts()
      : shouldShowLinkInvestmentsGreeting
      ? renderLinkInvestmentsGreeting()
      : renderLinkedAccounts();
  }
}

export default connect(
  state => ({
    user: state.register.user,
    step: state.register.linkBank,
    studentStep: state.register.student,
    networkingError: state.register.networkingError,
    loginsRequired: state.register.loginsRequired,
    finicityLoginsRequired: state.register.finicityLoginsRequired,
    applicationProgress: state.register.applicationProgress,
    aggregatorType: state.register.aggregatorType,
    finicityCustomerId: state.register.user.finicityCustomerId,
    email: state.register.user.email,
    plaidLinkToken: state.register.plaidLinkToken,
  }),
  actions
)(withModal(LinkBank));